import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Form,
  Button,
  Alert,
  Container,
  Row,
  Col,
  Spinner,
  Modal
} from "react-bootstrap";
function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);
    setLoading(true);
    if (password !== confirmPassword) {
      setError("Las contraseñas no coinciden.");
      setLoading(false);
      return;
    }
    try {
      const response = await fetch(
        "https://axarquiasostenibleapp.com/api/api/register",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password }),
        }
      );
      const data = await response.json();
      if (response.ok) {
        setSuccess(true);
        setTimeout(() => navigate("/login"), 2000);
      } else {
        setError(data.error || data.msg || "Error al registrar el usuario.");
      }
    } catch (err) {
      console.error("Error de red:", err);
      setError("Error de red: No se pudo conectar al servidor.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className=" bg-custom">
      <Container
        className="d-flex align-items-center justify-content-center"
        style={{ minHeight: "100vh" }}
      >
        <Row className="w-100">
          <div className="mt-0 text-center  ">
            <img src="/images/as_logo.png" alt="Logo" className="mt-5 mb-3" />
          </div>
          <Col xs={12} md={6} className="mx-auto">
            <div className="p-2 rounded bg-card-custom">
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-2" controlId="formEmail">
                  <Form.Control
                    type="email"
                    placeholder="Correo electrónico"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-2" controlId="formPassword">
                  <Form.Control
                    type="password"
                    placeholder="Contraseña"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-2" controlId="formConfirmPassword">
                  <Form.Control
                    type="password"
                    placeholder="Confirmar contraseña"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                  />
                </Form.Group>
                {error && <Alert variant="danger">{error}</Alert>}
                {success && (
                  <Alert variant="success">
                    Registro exitoso. Redirigiendo...
                  </Alert>
                )}
                <Button
                  type="submit"
                  className="w-100 btn-card-primary-custom"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                      Registrando...
                    </>
                  ) : (
                    "Registrarse"
                  )}
                </Button>
              </Form>
              <p className="text-center mt-3 p-custom">
                ¿Tienes una cuenta?{" "}
                <a href="/login" className="text-decoration-none a-custom">
                  <b>Inicia sesión aquí</b>
                </a>
                <i
                  onClick={() => setShowHelpModal(true)}
                  style={{ cursor: "pointer", color: "#009b3d" }}
                  class="bi bi-question-circle fs-6 p-2"
                ></i>
              </p>
            </div>
            <Modal
              show={showHelpModal}
              size="lg"
              onHide={() => setShowHelpModal(false)}
            >
              <Modal.Header closeButton className="bg-card-custom">
                <Modal.Title>Ayuda </Modal.Title>
              </Modal.Header>
              <Modal.Body className="bg-card-custom-image">
                {" "}
                Contacte con nosotros mediante este email si desea consultar
                alguna duda o comunicar alguna incidencia.
                <p className="text-center">
                  <b>departamento.idi@trops.es</b>
                </p>
              </Modal.Body>
              <Modal.Footer className="bg-card-custom">
                <Button
                  className="w-100 btn-danger-custom"
                  onClick={() => setShowHelpModal(false)}
                >
                  Cerrar
                </Button>
              </Modal.Footer>
            </Modal>
            <div className="mt-2">
              <small style={{ color: "#009b3d" }}>
                El Grupo Operativo Axarquía Sostenible está subvencionado
                mediante el Fondo Europeo de Agrícola de Desarrollo Rural
                (FEADER), por la Junta de Andalucía a través de la Consejería de
                Agricultura, Ganadería, Pesca y Desarrollo Sostenible, de
                acuerdo con el artículo 18.4 la Ley 38/2003, de 17 de noviembre.
              </small>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
export default Register;
